import Splide from '@splidejs/splide'

export default class Image
{
	static init()
	{
		this.gallery()
		this.lazyload()
	}

	static gallery()
	{
		const gallery = $('.__gallery')
		if(gallery.length === 0) return

		gallery.magnificPopup({
			type   : 'image',
			zoom   : {
				enabled: true,
				easing : 'ease-in-out',
			},
			gallery: {
				enabled : true,
				tPrev   : '前',
				tNext   : '次',
				tCounter: '%curr% / %total%',
				preload : [1, 1],
			},
			image  : {
				titleSrc: 'title',
				tError  : '画像がありません',
			},
		})

		gallery.on('mouseenter', (event) =>
		{
			document.createElement('img').src = event.currentTarget.href
		})
	}

	static lazyload()
	{
		if(lazyload) lazyload()
	}

	static slider(parameter = {})
	{
		$(parameter.element || '.splide').each(function()
		{
			const updateHeight = newIndex =>
			{
				const slide = slider.Components.Slides.getAt(typeof newIndex === 'number' ? newIndex : slider.index).slide
				slide.parentElement.parentElement.style.height = slide.firstElementChild.offsetHeight + 'px'
			}

			const slider = new Splide(this, {
				perPage    : parameter.perPage && parameter.perPage.pc || 1,
				arrows     : parameter.arrows && parameter.arrows.pc || false,
				pagination : parameter.pagination && parameter.pagination.pc || false,
				padding    : parameter.padding || 0,
				drag       : parameter.drag && parameter.drag.pc,
				autoplay   : parameter.autoplay,
				interval   : parameter.interval,
				type       : parameter.type || 'slide',
				rewind     : parameter.rewind,
				breakpoints: {
					767: {
						perPage   : parameter.perPage && parameter.perPage.sp || 1,
						arrows    : parameter.arrows && parameter.arrows.sp || false,
						pagination: parameter.pagination && parameter.pagination.sp || false,
						drag      : parameter.drag && parameter.drag.sp,
					},
				},
			}).mount()

			if(parameter.dynamicHeight)
			{
				slider.on('move resize', updateHeight)
				updateHeight()
			}
		})
	}

	static slider_manual(element, parameter)
	{
		return new Splide(element, parameter)
	}
}
